import { useEffect, useState } from "react";
import { authenticationModuleNames } from "../../utils/constants";
import LoginWrapper from "./LoginWrapper";
import OtpVerificationWrapper from "./OtpVerificationWrapper";
import SignUpWrapper from "./SignUpWrapper";
import ForgotPasswordWrapper from "./ForgotPasswordWrapper";
import ForgotPasswordOtpWrapper from "./ForgotPasswordOtpWrapper";

const Authentication = ({
	isError,
	setIsError,
	toasterMessage,
	setToasterMessage,
	notificationPopup,
	setNotificationPopup,
	email,
	password
}: {
	isError?: boolean | any;
	setIsError?: React.Dispatch<React.SetStateAction<boolean>> | any;
	toasterMessage?: string | any;
	setToasterMessage?: React.Dispatch<React.SetStateAction<string>> | any;
	notificationPopup?: boolean | any;
	setNotificationPopup?: React.Dispatch<React.SetStateAction<boolean>> | any;
	email?: string;
	password?: string;
}) => {
	const [switchComponent, setSwitchComponent] = useState(authenticationModuleNames.SIGN_IN);

	const [emailValue, setEmailValue] = useState("");
	const [passwordValue, setPasswordValue] = useState("");
	const [requestOtpEmail, setRequestOtpEmail] = useState("");

	const [isSignIn, setIsSignIn] = useState(false);
	const [isSignUp, setIsSignUp] = useState(false);

	useEffect(()=>{
		setEmailValue(email || "");
		setPasswordValue(password || "")
	}, [email, password])

	return (
		<div
			className={`mt-${switchComponent === authenticationModuleNames.SIGN_IN ? "0" : "4"} pb-4`}
		>
			{switchComponent === authenticationModuleNames.SIGN_IN && (
				<div className="announcement-card">
					<div className="announcement-body text-center">
						<h3 className="announce_new text-center">Authentication Required</h3>
						<div className="warning-txt">
							This module can be accessed only by event registered users. Login with
							registered email address to proceed.
						</div>
					</div>
				</div>
			)}

			{switchComponent === authenticationModuleNames.SIGN_IN && (
				<LoginWrapper
					emailValue={emailValue}
					passwordValue={passwordValue}
					setIsSignIn={setIsSignIn}
					setIsSignUp={setIsSignUp}
					setRequestOtpEmail={setRequestOtpEmail}
					setSwitchComponent={setSwitchComponent}
					isError={isError}
					setIsError={setIsError}
					toasterMessage={toasterMessage}
					setToasterMessage={setToasterMessage}
					notificationPopup={notificationPopup}
					setNotificationPopup={setNotificationPopup}
				/>
			)}

			{switchComponent === authenticationModuleNames.OTP_VERIFICATION && (
				<OtpVerificationWrapper
					isSignIn={isSignIn}
					isSignUp={isSignUp}
					requestOtpEmail={requestOtpEmail}
					setEmailValue={setEmailValue}
					setSwitchComponent={setSwitchComponent}
					isError={isError}
					setIsError={setIsError}
					toasterMessage={toasterMessage}
					setToasterMessage={setToasterMessage}
					notificationPopup={notificationPopup}
					setNotificationPopup={setNotificationPopup}
				/>
			)}

			{switchComponent === authenticationModuleNames.SIGN_UP && (
				<SignUpWrapper
					emailValue={emailValue}
					setEmailValue={setEmailValue}
					setIsSignIn={setIsSignIn}
					setIsSignUp={setIsSignUp}
					setRequestOtpEmail={setRequestOtpEmail}
					setSwitchComponent={setSwitchComponent}
					isError={isError}
					setIsError={setIsError}
					toasterMessage={toasterMessage}
					setToasterMessage={setToasterMessage}
					notificationPopup={notificationPopup}
					setNotificationPopup={setNotificationPopup}
				/>
			)}

			{switchComponent === authenticationModuleNames.FORGOT_PASSWORD && (
				<ForgotPasswordWrapper
					setEmailValue={setEmailValue}
					setSwitchComponent={setSwitchComponent}
					isError={isError}
					setIsError={setIsError}
					toasterMessage={toasterMessage}
					setToasterMessage={setToasterMessage}
					notificationPopup={notificationPopup}
					setNotificationPopup={setNotificationPopup}
				/>
			)}

			{switchComponent === authenticationModuleNames.FORGOT_PASSWORD_OTP && (
				<ForgotPasswordOtpWrapper
					emailValue={emailValue}
					setSwitchComponent={setSwitchComponent}
					isError={isError}
					setIsError={setIsError}
					toasterMessage={toasterMessage}
					setToasterMessage={setToasterMessage}
					notificationPopup={notificationPopup}
					setNotificationPopup={setNotificationPopup}
				/>
			)}
		</div>
	);
};

export default Authentication;
